// extracted by mini-css-extract-plugin
export default {"wrapper":"Detail_wrapper__uj68q","col":"Detail_col__PEwrc"};